import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"

import {
  getAccountLoanStatusList,
  getAccountLoanStatusById,
  createAccountLoanStatus,
  updateAccountLoanStatus,
  deleteAccountLoanStatus,
} from "api/accountLoanStatusApi"

export const ACCOUNT_LOAN_STATUS_QUERY_KEY = "account-loan-status"

export const useAccountLoanStatuses = (params = {}, enabled = true) => {
  return usePaginatedResource(
    ACCOUNT_LOAN_STATUS_QUERY_KEY,
    getAccountLoanStatusList,
    params,
    enabled
  )
}

export const useAccountLoanStatus = (id, enabled = true) => {
  return useResourceItem(
    ACCOUNT_LOAN_STATUS_QUERY_KEY,
    getAccountLoanStatusById,
    id,
    enabled
  )
}

export const useCreateAccountLoanStatus = () => {
  return useCreateResource(
    createAccountLoanStatus,
    ACCOUNT_LOAN_STATUS_QUERY_KEY
  )
}

export const useEditAccountLoanStatus = () => {
  return useEditResource(
    updateAccountLoanStatus,
    ACCOUNT_LOAN_STATUS_QUERY_KEY
  )
}

export const useDeleteAccountLoanStatus = () => {
  return useDeleteResource(
    deleteAccountLoanStatus,
    ACCOUNT_LOAN_STATUS_QUERY_KEY
  )
}
